import * as Config from '../../../config';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { showMenu } from 'react-contextmenu/modules/actions';

import useActionUser from './hooks/useActionUser';

import IconActions from './svg/IconActions';

function ButtonMore({ userID }) {
  const el = useRef();
  const { isEnable, prepareContextMenu } = useActionUser(userID);
  const showContextMenu = () => {
    if (isEnable) {
      prepareContextMenu(); // Based on permission
      const p = el.current.getBoundingClientRect();
      showMenu({
        position: {x: p.left, y: p.top + p.height},
        target: {},
        id: `DynamicMenu`
      })
    }
  }
  return isEnable ? (
    <div className={'icon-button-more'} ref={el} onClick={showContextMenu} style={{cursor: isEnable ? `pointer` : `default`}}>
      <IconActions color={ isEnable ? Config.TYPE_DARK_SECONDARY : Config.TYPE_DISABLE } />
    </div>
  ) : null
}

ButtonMore.propTypes = {
  userID: PropTypes.number.isRequired
}

export default ButtonMore;
